var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "ia-result" }, [
    _c("div", { staticClass: "ia-result-message" }, [
      _vm._v(" " + _vm._s(_setup.TEXT.noResults) + " "),
    ]),
    _c("div", { staticClass: "ia-result-suggestions-title" }, [
      _vm._v(" " + _vm._s(_setup.TEXT.suggestionsTitle) + " "),
    ]),
    _c("ul", { staticClass: "ia-result-suggestions-list" }, [
      _c("li", [_vm._v(_vm._s(_setup.TEXT.suggestion1))]),
      _c("li", [_vm._v(_vm._s(_setup.TEXT.suggestion2))]),
      _c("li", [_vm._v(_vm._s(_setup.TEXT.suggestion3))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }